import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ViewType } from 'app/shared/documents/models/rows.model';

@Component({
  selector: 'core-lay-toggler-view-type',
  templateUrl: './toggler-view-type.component.html',
  styleUrls: ['./toggler-view-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TogglerViewTypeComponent {
  @Input()
  viewType!: ViewType;

  @Output()
  toggleViewTypeClick = new EventEmitter<ViewType>();

  ViewType = ViewType;

  onToggleViewTypeClick(): void {
    if (this.viewType === ViewType.List) {
      this.viewType = ViewType.Thumbnails;
    } else {
      this.viewType = ViewType.List;
    }
    this.toggleViewTypeClick.emit(this.viewType);
  }
}
